<template>
    <component :is="tag">
        <span class="street">
            {{ (info.streetAddress || '').replace(/, */g, ', ') }}
        </span>
        <span class="city">
            {{ (info.cityAddress || '').replace(/, */g, ', ') }}
        </span>
    </component>
</template>

<script>
import { mapState } from '@/store/helpers';

export default {
    props: {
        tag: {
            type: String,
            default: 'h1' // To keep the template the same
        }
    },
    data: function() {
        return {};
    },
    computed: {
        ...mapState({
            info: store => store.listingDetail.info || {}
        })
    }
};
</script>
